<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title text-primary pl-2 pl-md-1">PAYOUT SUMMARY</h5>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <!-- <div class="col-lg-12">
              <button
                type="button"
                class="btn button-color btn-rounded text-white pl-4 pr-4 mr-4 mt-md-1 mt-2"
                (click)="filterPayout()"
              >
                ALL
              </button>
              <button
                type="button"
                class="btn button-color btn-rounded text-white pl-4 pr-4 mr-4 mt-md-1 mt-2"
                (click)="filterPayout()"
              >
                ON HOLD
              </button>
              <button
                type="button"
                class="btn button-color btn-rounded text-white pl-4 pr-4 mr-4 mt-md-1 mt-2"
                (click)="filterPayout()"
              >
                PROCESSED
              </button>
            </div> -->
          </div>

          <div class="row" *ngIf="transactions && transactions?.length > 0">
            <div class="col-md-12 mt-3 detail-tbl">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col" class="font-size-15 font-weight-500 w-15">
                        &nbsp;
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-25">
                        TRANSFER ID
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-15">
                        AMOUNT
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-15">
                        STATUS
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-25">
                        APPOINTMENT ID
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-25">
                        PHYSICIAN ID
                      </th>
                    </tr>
                  </thead>
                  <tr *ngFor="let payout of transactions">
                    <td class="font-size-15">
                      <div class="form-check ml-5">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [(ngModel)]="payout.isChecked"
                          id="defaultCheck1"
                          (change)="markSelected()"
                          *ngIf="
                            payout?.status == 'ON HOLD' && payout.transfer_id
                          "
                        />
                      </div>
                    </td>
                    <td class="font-size-15 text-color">
                      {{
                        payout?.transfer_id
                          ? payout?.transfer_id
                          : "Not Available"
                      }}
                    </td>
                    <td class="font-size-15 text-color">
                      {{ payout?.fee ? payout?.fee : "Not Available" }}
                    </td>
                    <td class="font-size-15 text-color">
                      {{ payout?.status ? payout?.status : "Not Available" }}
                    </td>
                    <td class="font-size-15 text-color">
                      {{ payout?.aptid ? payout?.aptid : "Not Available" }}
                    </td>
                    <td class="font-size-15 text-color">
                      {{ payout?.drid ? payout?.drid : "Not Available" }}
                    </td>
                  </tr>
                  <tbody>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="transactions && transactions?.length > 0">
        <div class="col-md-12 mb-5">
          <button
            type="button"
            class="btn btn-primary btn-rounded text-white pl-4 pr-4 mr-4 mt-md-1 mt-2"
            [disabled]="!selectedTransactions"
            (click)="payout()"
          >
            PAYOUT
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div
  class="container-fluid"
  *ngIf="transactions?.length === 0 || !transactions"
>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 mt-2 text-center">
              <h5 class="text-danger">NO TRANSFER FOUND</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
